import dayjs from '@tt/dates/dayjs';

const NY_TZ = 'America/New_York';
const PAID_COHORT_START_DATE = dayjs.tz('2025-10-24', 'YYYY-MM-DD', NY_TZ);

const nyNow = () => dayjs().tz(NY_TZ);

export const LIABILITY_RANGE_PRESETS = [
    {
        key: 'last7',
        label: 'Last 7 days',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(6, 'day').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last30',
        label: 'Last 30 days',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(29, 'day').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last3Months',
        label: 'Last 3 months',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(3, 'month').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last6Months',
        label: 'Last 6 months',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(6, 'month').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'sinceInception',
        label: 'Since Oct 24, 2025',
        getRange: () => {
            const today = nyNow();
            return [PAID_COHORT_START_DATE.startOf('day'), today.endOf('day')];
        }
    }
];

export const TRADING_RANGE_PRESETS = [
    {
        key: 'today',
        label: 'Today',
        getRange: () => {
            const today = nyNow();
            return [today.startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'yesterday',
        label: 'Yesterday',
        getRange: () => {
            const yesterday = nyNow().subtract(1, 'day');
            return [yesterday.startOf('day'), yesterday.endOf('day')];
        }
    },
    {
        key: 'last7',
        label: 'Last 7 days',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(6, 'day').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last30',
        label: 'Last 30 days',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(29, 'day').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last3Months',
        label: 'Last 3 months',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(3, 'month').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'last6Months',
        label: 'Last 6 months',
        getRange: () => {
            const today = nyNow();
            return [today.subtract(6, 'month').startOf('day'), today.endOf('day')];
        }
    },
    {
        key: 'sinceInception',
        label: 'Since Oct 24, 2025',
        getRange: () => {
            const today = nyNow();
            return [PAID_COHORT_START_DATE.startOf('day'), today.endOf('day')];
        }
    }
];
